/**
 * Status uczestnika w rezerwacji.
 *
 * Rezygnacja nie kasuje uczestnika: zostaje on w rezerwacji bez pozycji
 * rachunku, żeby historia i rozliczenie miały do czego się odnosić.
 */
export enum ParticipantStatus {
  ACTIVE = 'ACTIVE',
  WITHDRAWN = 'WITHDRAWN',
}
